/*
 * author ivanm
 */
define(function(require) {
    "use strict";

    var LE = require("app");
    var Button = require("ui/button/Button");
    var StepIndicator = require("ui/stepIndicator/StepIndicator");
    var InputField = require("ui/input-field/InputField");
    var Dropdown = require("ui/dropdown/Dropdown");
    var Loader = require("ui/loader/Loader");
    var Bubble = require("ui/bubble/Bubble");
    var Validator = require("registration-utils/Validator");
    var Config = require("registration-assets/config/config.json");
    var CountryUtility = require("infra-util/CountryUtility");
    var IndustryUtility = require("utils/IndustryUtility");
    var XRegExp = require("xregexp").XRegExp;
    var BuyNowInfoView = {};

    LE.module('LERegistration', function(LERegistration, LE, Backbone, Marionette) {
        var COMPONENTS = {
            FIRST_NAME_INPUT: "firstNameInput",
            LAST_NAME_INPUT: "lastNameInput",
            WEBSITE_INPUT: "websiteInput",
            EMAIL_ADDRESS_INPUT: "emailAddressInput",
            PASSWORD_INPUT: "passwordInput",
            CONFIRM_PASSWORD_INPUT: "passwordConfirmInput"
        };

        var ERRORS = {
            FIRST_NAME_INVALID: "firstNameInvalid",
            FIRST_NAME_EMPTY: "firstNamedEmpty",
            LAST_NAME_INVALID: "lastNameInvalid",
            LAST_NAME_EMPTY: "lastNameEmpty",
            WEB_SITE_INVALID: "webSiteInvalid",
            WEB_SITE_EMPTY: "webSiteEmpty",
            EMAIL_ADDRESS_INVALID: "emailAddressInvalid",
            EMAIL_ADDRESS_EMPTY: "emailAddressEmpty",
            PASSWORD_EMPTY: "passwordEmpty",
            PASSWORD_LENGTH: "passwordLength",
            PASSWORD_MATCH: "passwordMatch"
        };

        var mapErrorToComponent = {};
        mapErrorToComponent[ERRORS.FIRST_NAME_INVALID] = COMPONENTS.FIRST_NAME_INPUT;
        mapErrorToComponent[ERRORS.FIRST_NAME_EMPTY] = COMPONENTS.FIRST_NAME_INPUT;
        mapErrorToComponent[ERRORS.LAST_NAME_INVALID] = COMPONENTS.LAST_NAME_INPUT;
        mapErrorToComponent[ERRORS.LAST_NAME_EMPTY] = COMPONENTS.LAST_NAME_INPUT;
        mapErrorToComponent[ERRORS.WEB_SITE_INVALID] = COMPONENTS.WEBSITE_INPUT;
        mapErrorToComponent[ERRORS.WEB_SITE_EMPTY] = COMPONENTS.WEBSITE_INPUT;
        mapErrorToComponent[ERRORS.EMAIL_ADDRESS_INVALID] = COMPONENTS.EMAIL_ADDRESS_INPUT;
        mapErrorToComponent[ERRORS.EMAIL_ADDRESS_EMPTY] = COMPONENTS.EMAIL_ADDRESS_INPUT;
        mapErrorToComponent[ERRORS.PASSWORD_EMPTY] = COMPONENTS.PASSWORD_INPUT;
        mapErrorToComponent[ERRORS.PASSWORD_LENGTH] = COMPONENTS.PASSWORD_INPUT;
        mapErrorToComponent[ERRORS.PASSWORD_MATCH] = COMPONENTS.CONFIRM_PASSWORD_INPUT;

        var that;

        BuyNowInfoView = Marionette.ItemView.extend({

            withUIComponents: true,

            template: require("registration-templates/buy-now/buyNowInfo.tmpl"),

            className: 'buy-now-info-view',

            initialize: function() {
                that = this;
            },

            ui: {
                firstNameDiv: ".first-name-div",
                lastNameDiv: ".last-name-div",
                registrationWebsiteDiv: ".website-div",
                registrationEmailAddressDiv: ".email-address-div",
                registrationChoosePasswordDiv: ".choose-password-div",
                registrationConfirmPasswordDiv: ".confirm-your-password-div",
                registrationCountryDiv: ".main-country-dd",
                registrationIndustryDiv: ".main-industry-dd",
                registrationCreateAccountButton: ".next-button",
                autoLoginForm: ".auto-login-form",
                autoLoginPassord: ".auto-login-password",
                siteId: ".lp-site-id",
                username: ".user-name",
                lpservice: ".lpservice",
                servicepath: ".servicepath",
                stepIndicator: ".step-indicator"
            },

            uiComponents: {
                firstNameInput: {
                    type: InputField,
                    options: {
                        el: "view.ui.firstNameDiv",
                        permutation: InputField.Permutation.M,
                        placeholder: LE.translator.translate("LERegistration.Fields.placeholder.first.name"),
                        tabindex: 1,
                        autoFocus: true,
                        value: "view._getFirstName"
                    }
                },
                lastNameInput: {
                    type: InputField,
                    options: {
                        el: "view.ui.lastNameDiv",
                        permutation: InputField.Permutation.M,
                        placeholder: LE.translator.translate("LERegistration.Fields.placeholder.last.name"),
                        tabindex: 2,
                        value: "view._getLastName"
                    }
                },
                websiteInput: {
                    type: InputField,
                    options: {
                        el: "view.ui.registrationWebsiteDiv",
                        permutation: InputField.Permutation.B,
                        placeholder: LE.translator.translate("LERegistration.EnterYourWebsiteAddressURL"),
                        tabindex: 3,
                        value: "view._getWebsite"
                    }
                },
                emailAddressInput: {
                    type: InputField,
                    options: {
                        el: "view.ui.registrationEmailAddressDiv",
                        permutation: InputField.Permutation.B,
                        placeholder: LE.translator.translate("LERegistration.Fields.placeholder.also.used.user.name"),
                        tabindex: 3,
                        value: "view._getEmailAddress"
                    }
                },
                regLocation: {
                    type: Dropdown,
                    options: {
                        container: "view.ui.registrationCountryDiv",
                        model: this.model,
                        name: 'location',
                        items: getCountries(),
                        tabindex: 4,
                        selectedOption: "view._getLocation"
                    }
                },
                regIndustry: {
                    type: Dropdown,
                    options: {
                        container: "view.ui.registrationIndustryDiv",
                        model: this.model,
                        name: 'industry',
                        items: getIndustries(),
                        tabindex: 5,
                        selectedOption: "view._getIndustry"
                    }
                },
                passwordInput: {
                    type: InputField,
                    options: {
                        el: "view.ui.registrationChoosePasswordDiv",
                        type: InputField.Type.Password,
                        permutation: InputField.Permutation.B,
                        placeholder: LE.translator.translate("LERegistration.EnterYourPassword"),
                        tabindex: 5
                    }
                },
                passwordConfirmInput: {
                    type: InputField,
                    options: {
                        el: "view.ui.registrationConfirmPasswordDiv",
                        type: InputField.Type.Password,
                        permutation: InputField.Permutation.B,
                        placeholder: LE.translator.translate("LERegistration.ConfirmYourPassword"),
                        tabindex: 6
                    }
                },
                nextButton: {
                    type: Button,
                    options: {
                        el: "view.ui.registrationCreateAccountButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY,
                        initState: Button.STATES.ENABLED,
                        tabindex: 7,
                        onClick: onNextButtonClick
                    }
                },
                stepIndicator: {
                    type: StepIndicator,
                    options: {
                        el: "view.ui.stepIndicator",
                        steps: [
                            { text: LE.translator.translate("LERegistration.BuyNow.stepIndicator.step1"), state: StepIndicator.STATE.CURRENT},
                            { text: LE.translator.translate("LERegistration.BuyNow.stepIndicator.step2"), state: StepIndicator.STATE.NOT_COMPLETED},
                            { text: LE.translator.translate("LERegistration.BuyNow.stepIndicator.step3"), state: StepIndicator.STATE.NOT_COMPLETED},
                        ]
                    }
                }
            },

            events: {
                'keypress input': 'keyPressEnter'
            },

            keyPressEnter: function(ev) {
                if (ev.keyCode === 13) {
                    $('.next-button .btn-primary').focus();
                    LERegistration.logger.info("BuyNowInfoView >> keyPressEnter >> ENTER was pressed");
                    onNextButtonClick(ev);
                }
            },

            onInvalid: function(model, errors) {
                LERegistration.logger.info("BuyNowInfoView >> onInvalid >> START");
                cleanAllErrorBubbles();
                setAllErrorBubbles(errors);
                LERegistration.logger.info("BuyNowInfoView >> onInvalid >> END");
            },


            onRender: function() {
                LERegistration.logger.info("BuyNowInfoView >> onRender >> START");
                var inputFieldUIComponents = this.uiComponents.firstNameInput;
                setTimeout(function() {
                    inputFieldUIComponents.setFocus(true);
                }, 0);
                LERegistration.logger.info("BuyNowInfoView >> onRender >> END");
            },

            onShow: function() {
                LERegistration.logger.info("BuyNowInfoView >> onShow >> START");
                LERegistration.logger.info("BuyNowInfoView >> onShow >> END");
            },

            _getFirstName: function() {
                return this.model.get("crmDetails.firstName");
            },

            _getLastName: function() {
                return this.model.get("crmDetails.lastName");
            },

            _getEmailAddress: function() {
                return this.model.get("crmDetails.email");
            },

            _getWebsite: function() {
                return this.model.get("crmDetails.website");
            },

            _getLocation: function() {
                var value = 'us';

                if (this.model.get("location")) {
                    value = this.model.get("location");
                }

                return value;
            },

            _getIndustry: function() {
                var value = 'Other';

                if (this.model.get("industry")) {
                    value = this.model.get("industry");
                }

                return value;
            },

            validateFirstName: function() {
                LERegistration.logger.info("RegistrationCreateAccountView >> validateFirstName >> START");
                var errors = {};
                if (Validator.isEmpty(this.uiComponents.firstNameInput.getValue())) {
                    errors[ERRORS.FIRST_NAME_EMPTY] = LE.translator.translate("LERegistration.FieldMandatory");
                } else if (!XRegExp.call(this, Config.validators.name.regex).test(this.uiComponents.firstNameInput.getValue())) {
                    errors[ERRORS.FIRST_NAME_INVALID] = LE.translator.translate("LERegistration.error.enter.valid.first.name");
                }
                LERegistration.logger.info("BuyNowInfoView >> validateFirstName >> END");
                return errors;
            },
            validateLastName: function() {
                LERegistration.logger.info("BuyNowInfoView >> validateLastName >> START");
                var errors = {};
                if (Validator.isEmpty(this.uiComponents.lastNameInput.getValue())) {
                    errors[ERRORS.LAST_NAME_EMPTY] = LE.translator.translate("LERegistration.FieldMandatory");
                } else if (!XRegExp.call(this, Config.validators.name.regex).test(this.uiComponents.lastNameInput.getValue())) {
                    errors[ERRORS.LAST_NAME_INVALID] = LE.translator.translate("LERegistration.error.enter.valid.last.name");
                }
                LERegistration.logger.info("BuyNowInfoView >> validateLastName >> END");
                return errors;
            },

            validateWebsite: function() {
                LERegistration.logger.info("BuyNowInfoView >> validateWebsite >> START");
                var errors = {};
                if (Validator.isEmpty(this.uiComponents.websiteInput.getValue())) {
                    errors[ERRORS.WEB_SITE_EMPTY] = LE.translator.translate("LERegistration.FieldMandatory");
                } else if (!Validator.isValid(this.uiComponents.websiteInput.getValue(), Config.validators.uri.regex)) {
                    errors[ERRORS.WEB_SITE_INVALID] = LE.translator.translate("LERegistration.PleaseEnterValidWebsite");
                }
                LERegistration.logger.info("BuyNowInfoView >> validateWebsite >> END");
                return errors;
            },

            validateEmail: function() {
                LERegistration.logger.info("BuyNowInfoView >> validateLastName >> START");
                var errors = {};
                if (Validator.isEmpty(this.uiComponents.emailAddressInput.getValue())) {
                    errors[ERRORS.EMAIL_ADDRESS_EMPTY] = LE.translator.translate("LERegistration.FieldMandatory");

                } else if (!XRegExp.call(this, Config.validators.email.regex).test(this.uiComponents.emailAddressInput.getValue())) {
                    errors[ERRORS.EMAIL_ADDRESS_INVALID] = LE.translator.translate("LERegistration.PleaseEnterValidEmail");
                }
                LERegistration.logger.info("BuyNowInfoView >> validateEmail >> END");
                return errors;
            },

            validatePassword: function() {
                LERegistration.logger.info("BuyNowInfoView >> validatePassword >> START");
                var errors = {};
                if (Validator.isEmpty(this.uiComponents.passwordInput.getValue())) {
                    LERegistration.logger.info("BuyNowInfoView >> validatePassword >> password empty");
                    errors[ERRORS.PASSWORD_EMPTY] = LE.translator.translate("LERegistration.FieldMandatory");
                } else {
                    if (!Validator.isPasswordValid(this.uiComponents.passwordInput.getValue())) {
                        LERegistration.logger.info("BuyNowInfoView >> validatePassword >> password not valid");
                        errors[ERRORS.PASSWORD_LENGTH] = LE.translator.translate("LERegistration.EnterValidPassword");
                    }
                }
                LERegistration.logger.info("BuyNowInfoView >> validatePassword >> END");
                return errors;
            },

            validateConfirmPassword: function() {
                LERegistration.logger.info("BuyNowInfoView >> validateConfirmPassword >> START");
                var errors = {};
                if (this.uiComponents.passwordInput.getValue() !== this.uiComponents.passwordConfirmInput.getValue()) {
                    errors[ERRORS.PASSWORD_MATCH] = LE.translator.translate("LERegistration.PasswordsNotMatch");
                }
                LERegistration.logger.info("BuyNowInfoView >> validateConfirmPassword >> END");
                return errors;
            },

            doValidate: function() {
                LERegistration.logger.info("BuyNowInfoView >> doValidate >> START");
                var errors = {};

                _.extend(errors, this.validateFirstName());
                _.extend(errors, this.validateLastName());
                _.extend(errors, this.validateWebsite());
                _.extend(errors, this.validateEmail());
                _.extend(errors, this.validatePassword());
                _.extend(errors, this.validateConfirmPassword());

                if (_.isEmpty(errors)) {
                    LERegistration.logger.info("RegistrationFailedCreateAccountView >> doValidate >> is valid");
                    return false;
                } else {
                    //show general error
                    //LERegistration.notifier.showError(LE.translator.translate("LEFramework.errors.generalError.on.page"));

                    //show only first error
                    //LERegistration.notifier.showError(errors[Object.keys(errors)[0]]);

                    //show all errors
                    var errMsgs= _.uniq(_.values(errors)).join("<br>");
                    LERegistration.notifier.showError(errMsgs);

                    LERegistration.logger.info("buy now form errors: ", "RegistrationFailedCreateAccountView:doValidate", errors);
                    return errors;
                }
                LERegistration.logger.info("BuyNowInfoView >> doValidate >> END");
            }
        });

        function getCountries() {
            LERegistration.logger.info("BuyNowInfoView >> getCountries >> START and RETURN countriesCollection");
            var countries = CountryUtility.getCountries();
            var countriesCollection = new Dropdown.Collection(countries);

            return countriesCollection;
        }

        function getIndustries() {
            LERegistration.logger.info("BuyNowInfoView >> getIndustries >> START and RETURN industriesCollection");
            var industries = IndustryUtility.getIndustries();
            var industriesCollection = new Dropdown.Collection(industries);

            return industriesCollection;
        }

        //TODO (Gal): should export this code (setAllErrorBubbles & setAllErrorBubbles) to a util class
        function cleanAllErrorBubbles() {
            LERegistration.logger.info("BuyNowInfoView >> cleanAllErrorBubbles >> START");
            for (var error in COMPONENTS) {
                that.uiComponents[COMPONENTS[error]].setError(false);
            }
            LERegistration.logger.info("BuyNowInfoView >> cleanAllErrorBubbles >> END");
        }

        function setAllErrorBubbles(errors) {
            LERegistration.logger.info("BuyNowInfoView >> setAllErrorBubbles >> START");
            for (var error in errors) {
                that.uiComponents[mapErrorToComponent[error]].setError(true, errors[error]);
            }
            LERegistration.logger.info("BuyNowInfoView >> setAllErrorBubbles >> END");
        }

        function prepareLoginURL(domain, siteId) {
            LERegistration.logger.info("BuyNowInfoView >> prepareLoginURL >> START and RETURN login url");
            return "https://" + domain + "/hc/s-" + siteId + "/web/m-LP/mlogin/home.jsp";
        }

        function onNextButtonClick() {
            LERegistration.logger.info("BuyNowInfoView >> vent >> registration:registrationBuyNowCheckout");
            var errors = that.doValidate();
            if (errors) {
                LERegistration.logger.info("BuyNowInfoView >> onNextButtonClick >> has errors >> errors=" + errors);
                that.onInvalid(null, errors);
            } else {
                LERegistration.logger.info("BuyNowInfoView >> onNextButtonClick >> START");


                that.model.set('crmDetails.firstName', that.uiComponents.firstNameInput.getValue());
                that.model.set('crmDetails.lastName', that.uiComponents.lastNameInput.getValue());
                that.model.set('crmDetails.email', that.uiComponents.emailAddressInput.getValue());
                that.model.set('crmDetails.website', that.uiComponents.websiteInput.getValue());
                that.model.set('location', that.uiComponents.regLocation.getValue());
                that.model.set('industry', that.uiComponents.regIndustry.getValue());
                that.model.set('password', that.uiComponents.passwordInput.getValue());

                that.trigger(BuyNowInfoView.TRIGGERING.NEXT_BUTTON_CLICKED);

                LERegistration.logger.info("BuyNowInfoView >> onNextButtonClick >> END");
            }
        }



    });

    BuyNowInfoView.TRIGGERING = {
        NEXT_BUTTON_CLICKED: "next"
    };

    return BuyNowInfoView;
});
